import React from 'react'
import { Outlet } from 'react-router-dom'

const PortfolioLayout = () => {
    return (
        <>
            <div className='PortfolioLayout mt-5'>
                <Outlet />
            </div>
        </>
    )
}

export default PortfolioLayout